import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StatusBadge from "./StatusBadge";
import { formatDateTime, hasStatusChip, statusAccentColor } from "./partnersMobileUtils";
import css from "./partnersMobile.module.css";

// One CP, carrying the same fields as the desktop CP grid: CPID + status chip,
// billing name, contact person, type, Created At and Last Updated. Tapping the
// body opens the detail page; the kebab opens the row's action menu.
export default function PartnerCard({ row, onOpen, onAction }) {
  const title = row.billingName || row.name || "—";
  const chip = { status: row.approvalStatus, disabled: row.Disabled };
  const showChip = hasStatusChip(chip);
  // Status-coloured left edge, as the CP Sourcing cards do per tier.
  const accent = statusAccentColor(showChip ? chip : {});

  return (
    <div className={css.card} style={{ borderLeftColor: accent }}>
      <div className={css.cardHeader}>
        <span className={css.cardId}>{row.cpDisplayId}</span>
        {showChip && <StatusBadge status={row.approvalStatus} disabled={row.Disabled} />}
        <span className={css.cardHeaderSpacer} />
        <button
          type="button"
          className={css.kebab}
          aria-label={`Actions for ${row.cpDisplayId}`}
          onClick={(e) => {
            // The card body is also clickable — do not let this bubble into it.
            e.stopPropagation();
            onAction(row);
          }}
        >
          <MoreVertIcon sx={{ fontSize: 20 }} />
        </button>
      </div>

      <button type="button" className={css.cardBody} onClick={() => onOpen(row)}>
        <div className={css.cardTitle}>{title}</div>
        <div className={css.kv}>
          <span className={css.kvKey}>Contact</span>
          <span className={css.kvValue}>{row.name || "—"}</span>
        </div>
        <div className={css.kv}>
          <span className={css.kvKey}>Type</span>
          <span className={css.kvValue}>{row.type || "—"}</span>
        </div>
        <div className={css.cardFooter}>
          <div>Created {formatDateTime(row.createdAt)}</div>
          <div>Updated {formatDateTime(row.lastUpdated)}</div>
        </div>
      </button>
    </div>
  );
}
